import Header from '@components/Header';
import { useTranslation } from 'react-i18next';

function OrderHeader() {
    const { t } = useTranslation('orderLog');
    return (
        <Header title={t('header.title')}/>
    );
}

export default OrderHeader;
